import { createContext, useContext } from "react";
import createPersistedReducer from "use-persisted-reducer";
import { libAdmin, libCaller, libCust, libMonitoring } from "../utils/defaultLibrary";

const usePersistedReducer = createPersistedReducer("stateLanguange");

const LanguangeContext = createContext();

export function useLanguangeContext() {
	return useContext(LanguangeContext);
}

const reducer = (state, action) => {
	switch (action.type) {
		case "SET_LANGUANGE":
			return { ...state, lang: action.payload };
		case "SET_LIB_ADMIN":
			return {
				...state,
				libraryAdmin: {
					...state.libraryAdmin,
					[action.payload.lang]: action.payload.data,
				},
			};
		case "SET_LIB_CALLER":
			return {
				...state,
				libraryCaller: { ...state.libraryCaller, ...action.payload },
			};
		case "SET_LIB_CUSTOMER":
			return {
				...state,
				libraryCust: { ...state.libraryCust, ...action.payload },
			};
		case "SET_LIB_MONITORING":
			return {
				...state,
				libraryMonitoring: { ...state.libraryMonitoring, ...action.payload },
			};
		case "RESET_LANGUAGE":
			return {
				...state,
				lang: "ID",
				libraryAdmin: { ID: libAdmin }, // fallback to default
				libraryCaller: libCaller,
				libraryCust: libCust,
				libraryMonitoring: libMonitoring,
			};
		default:
			return state;
	}
};

const initialState = {
	lang: "ID",
	libraryAdmin: { ID: libAdmin }, // nested by lang
	libraryCaller: libCaller,
	libraryCust: libCust,
	libraryMonitoring: libMonitoring,
};

export function LanguangeProvider({ children }) {
	const [state, dispatch] = usePersistedReducer(reducer, initialState);

	const setLanguange = (lang) =>
		dispatch({ type: "SET_LANGUANGE", payload: lang });

	const setLibAdmin = (lang, data) =>
		dispatch({ type: "SET_LIB_ADMIN", payload: { lang, data } });

	const setLibCaller = (data) =>
		dispatch({ type: "SET_LIB_CALLER", payload: data });

	const setLibCustomer = (data) =>
		dispatch({ type: "SET_LIB_CUSTOMER", payload: data });

	const setLibMonitoring = (data) =>
		dispatch({ type: "SET_LIB_MONITORING", payload: data });

	const resetLanguange = () => dispatch({ type: "RESET_LANGUAGE" });

	const value = {
		...state,
		setLanguange,
		setLibAdmin,
		setLibCaller,
		setLibCustomer,
		setLibMonitoring,
		resetLanguange,
	};

	return (
		<LanguangeContext.Provider value={value}>
			{children}
		</LanguangeContext.Provider>
	);
}
